function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.49626 4.43541L1.23267 0.215311C1.08765 0.0717705 0.91846 0.00239217 0.725101 0.00717723C0.53174 0.0119618 0.362551 0.0861243 0.21753 0.229665C0.0725108 0.373206 6.51019e-08 0.54067 6.28196e-08 0.732057C6.05373e-08 0.923445 0.0725108 1.09091 0.21753 1.23445L4.66964 5.6555C4.78566 5.77033 4.91618 5.85646 5.0612 5.91388C5.20622 5.97129 5.35124 6 5.49626 6C5.64128 6 5.7863 5.97129 5.93132 5.91388C6.07634 5.85646 6.20686 5.77033 6.32287 5.6555L10.7895 1.23445C10.9345 1.09091 11.0046 0.921053 10.9998 0.724881C10.9949 0.528708 10.92 0.358852 10.775 0.215312C10.63 0.0717707 10.4608 4.70407e-07 10.2674 4.68101e-07C10.0741 4.65795e-07 9.90487 0.0717707 9.75985 0.215312L5.49626 4.43541Z",
  fill: "#505575"
});

var SvgArrowDown = function SvgArrowDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow_down.4982a903.svg";
export { ForwardRef as ReactComponent };